// NotificationsPage.js
import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';
import NotificationCard from './NotificationCard';

export default function NotificationsPage() {
  const { token } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [userProfiles, setUserProfiles] = useState({});
  const [unread, setUnread] = useState(0);

  // Charge les notifications depuis l’API
  const fetchNotifications = async () => {
    try {
      const res = await fetch("/notifications/me", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
      const data = await res.json();
      setNotifications(Array.isArray(data.items) ? data.items : []);
      setUnread(data.unread || 0);
    } catch (err) {
      console.error("Erreur chargement notifications :", err);
      setNotifications([]);
      setUnread(0);
    }
  };

  useEffect(() => {
    if (token) {
      fetchNotifications();
    }
  }, [token]);

  // Charge les profils utilisateurs
  useEffect(() => {
    if (!token) return;
    fetch("/users", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        const map = {};
        if (Array.isArray(data)) {
          data.forEach(u => (map[u.username] = u));
        }
        setUserProfiles(map);
      })
      .catch(err => {
        console.error("Erreur chargement utilisateurs :", err);
      });
  }, [token]);

  // Prendre une décision (approuver/refuser)
  const handleDecision = async (notif, decision, reason = '') => {
    try {
      const res = await fetch(`/projects/${notif.project_id}/access-decision`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          user_id: notif.user_id,
          decision,
          reason,
          notif_id: notif.id
        })
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Erreur ${res.status} : ${errorText}`);
      }

      const data = await res.json();
      console.log('Décision enregistrée :', data);

      // Recharge les notifs après décision
      fetchNotifications();
    } catch (err) {
      console.error("Erreur lors de la décision :", err);
      alert("Une erreur est survenue : " + err.message);
    }
  };

  return (
    <div className="container mt-5" style={{ paddingTop: '70px' }}>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i className="bi bi-bell fs-3" aria-hidden="true"></i>
        <h2 className="m-0">Centre de notifications</h2>
      </div>

   <div className="d-flex justify-content-between align-items-center mb-4">
  <p className="text-muted m-0">
    Vous avez {notifications.length} notification(s)
    {unread > 0 && <> — <span className="badge bg-danger">{unread} non lues</span></>}
  </p>
  <div className="d-flex gap-2">
    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={async () => {
        try {
          await fetch('/notifications/read-all', {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
          });
          // local state update
          setNotifications(prev => prev.map(n => ({ ...n, is_read: 1 })));
          setUnread(0);
        } catch (e) {
          console.error('read-all failed', e);
        }
      }}
      disabled={unread === 0}
    >
      <i className="bi bi-check2-all me-1" /> Tout marquer comme lu
    </button>
    <Link to="/admin/access-log" className="btn btn-outline-dark btn-sm">
      <i className="bi bi-journal-text me-2" aria-hidden="true"></i>
      Voir l’historique des décisions
    </Link>
  </div>
</div>


      {notifications.length === 0 ? (
        <div className="text-center text-muted py-5">
          <i className="bi bi-inbox fs-1 d-block mb-2" aria-hidden="true"></i>
          <div>Aucune notification</div>
        </div>
      ) : (
        <div className="row g-3">
          {notifications.map((notif) => (
            <div key={notif.id} className="col-12 col-md-6 col-lg-4">
              <NotificationCard
                notif={notif}
                user={userProfiles[notif.user_id]}
                onDecision={handleDecision}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
